import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorOptionsCard } from '../components/processor-options-card'

interface FinixProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const FinixProcessorDetailsPage = ({ processor }: FinixProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="finix"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorOptionsCard processor={processor} />
        </>
    )
}
